/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Agent_Image_RoleInputs */

const tr_landing_genius_agent_image_role = /** @type {(inputs: Landing_Genius_Agent_Image_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ürün görselleri`)
};

const en_landing_genius_agent_image_role = /** @type {(inputs: Landing_Genius_Agent_Image_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`product images`)
};

const de_landing_genius_agent_image_role = /** @type {(inputs: Landing_Genius_Agent_Image_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktbilder`)
};

const ru_landing_genius_agent_image_role = /** @type {(inputs: Landing_Genius_Agent_Image_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`изображения товаров`)
};

/**
* | output |
* | --- |
* | "product images" |
*
* @param {Landing_Genius_Agent_Image_RoleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_agent_image_role = /** @type {((inputs?: Landing_Genius_Agent_Image_RoleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Agent_Image_RoleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_agent_image_role(inputs)
	if (locale === "de") return de_landing_genius_agent_image_role(inputs)
	if (locale === "ru") return ru_landing_genius_agent_image_role(inputs)
	return tr_landing_genius_agent_image_role(inputs)
});